import Base from '@studiometa/js-toolkit';
import scroll from '../utils/scroll';

/**
 * @typedef {Object} GlossaryNavRef
 * @property {HTMLElement} container
 * @property {HTMLElement[]} items[]
 * @property {HTMLButtonElement[]} navItems[]
 */

/**
 * @typedef {Object} GlossaryNavInterface
 * @property {GlossaryNavRef} $refs
 * @property {Number} index
 */

/**
 * Homepage class.
 */
export default class GlossaryNav extends Base {
  /**
   * Class config
   * @type {Object}
   */
  static config = {
    name: 'GlossaryNav',
    refs: ['container', 'items[]', 'navItems[]'],
  };

  /**
   * Initialize the component's behavior.
   *
   * @this {GlossaryNav & GlossaryNavInterface}
   */
  mounted() {
    this.index = 0;
    this.draw();

    this.$refs.navItems
      .filter((navItem) => navItem.disabled === false)
      .forEach((navItem, navItemIndex) => {
        navItem.addEventListener('click', () => {
          scroll(
            this.$refs.items[navItemIndex].getBoundingClientRect().top +
              window.scrollY -
              this.$refs.container.clientHeight +
              1
          );
        });
      });

    window.addEventListener('scroll', this.onScroll);
  }

  /**
   * Draw function
   *
   * @this {GlossaryNav & GlossaryNavInterface}
   * @return {void}
   */
  draw() {
    this.$refs.navItems
      .filter((navItem) => navItem.disabled === false)
      .forEach((item, itemIndex) => {
        item.classList.remove('active');

        if (itemIndex === this.index) {
          item.classList.add('active');
        }
      });
  }

  /**
   * Window resized event.
   *
   * @this {GlossaryNav & GlossaryNavInterface}
   */
  resized() {
    this.draw();
  }

  /**
   * Window scrolled event.
   *
   * @this {GlossaryNav & GlossaryNavInterface}
   */
  onScroll() {
    const itemsTop = this.$refs.items.map(
      (item) => item.offsetTop - window.scrollY - this.$refs.container.clientHeight
    );

    const index = Math.max(
      0,
      itemsTop.map((itemTop) => (itemTop < 0 ? 1 : 0)).reduce((acc, curr) => acc + curr, -1)
    );

    if (index !== this.index) {
      this.index = index;
      this.draw();
    }

    this.$refs.container.style.top = `${document
      .querySelector('.header')
      .getAttribute('data-offset')}px`;
  }

  /**
   * Unbind all events on destroy.
   *
   * @this {GlossaryNav & GlossaryNavInterface}
   * @return {GlossaryNav} The GlossaryNav instance.
   */
  destroyed() {
    return this;
  }
}
